module.exports = __webpack_public_path__ + "img/handyman_a.f94a8556.jpg";